import React, { memo } from "react";
import { locations } from "../../../../Utils/data";
import Button from "../../../Button/Button";
import LocationCard from "./LocationCard/LocationCard";

const TreatmentLocationStep = ({
  handleNextStep,
  handleBackStep,
  setLocation,
  location,
}) => {
  return (
    <>
      <p className="font-font-Montserrat font-light text-[18px] text-[#262626] text-center leading-[27px] tracking-[0.0313em]">
        You have the flexibility to choose from a vast list of services and
        customize the plan to suit your needs
      </p>
      <p className="font-font-Montserrat font-semibold text-[22px] text-[#262626] text-center leading-[33px] tracking-[0.0094em] mt-16">
        To begin with, please choose where you want the treatment to be
        conducted at:
      </p>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 my-4 justify-center items-center">
        {locations?.map((item) => (
          <LocationCard
            image={item?.image}
            name={item?.name}
            price={item?.price}
            setLocation={setLocation}
            location={location}
          />
        ))}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-6 justify-center mt-40">
        <Button
          name={`< BACK`}
          background="#FFFFFF"
          classNames="uppercase bg-none border border-solid border-[#141414] w-[193px]"
          divStyle="col-span-2 justify-center sm:justify-end"
          onClickHandler={handleBackStep}
        />
        <Button
          name={`Continue >`}
          classNames="uppercase disabled:bg-[#D9D9D9] disabled:cursor-not-allowed hover:bg-[#FFC53D] w-[193px]"
          divStyle="col-span-2 justify-center sm:justify-start"
          onClickHandler={handleNextStep}
          disabled={!location}
        />
      </div>
    </>
  );
};
export default memo(TreatmentLocationStep);
